document.addEventListener("DOMContentLoaded", async () => {
  const RECENTLY_VIEWED_KEY = "dreambaby-recently-viewed";
  const MAX_RECENTLY_VIEWED = 12;

  // --- Part 1: Track recently viewed products on product pages ---
  let currentProductId = null;
  const productJsonScript = document.querySelector("#product-json");
  if (productJsonScript) {
    try {
      const productData = JSON.parse(productJsonScript.textContent);
      if (productData) {
        currentProductId = productData.id;
        addProductToSessionStorage(productData);
      }
    } catch (error) {
      console.error("[Recently Viewed] Error parsing product JSON:", error);
    }
  }

  function addProductToSessionStorage(product) {
    let recentlyViewed = getRecentlyViewed();
    const existingIndex = recentlyViewed.findIndex((p) => p.id === product.id);
    if (existingIndex > -1) recentlyViewed.splice(existingIndex, 1);
    recentlyViewed.unshift(product);
    if (recentlyViewed.length > MAX_RECENTLY_VIEWED) {
      recentlyViewed = recentlyViewed.slice(0, MAX_RECENTLY_VIEWED);
    }
    sessionStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(recentlyViewed));
  }

  function getRecentlyViewed() {
    const storedValue = sessionStorage.getItem(RECENTLY_VIEWED_KEY);
    try {
      return storedValue ? JSON.parse(storedValue) : [];
    } catch {
      return [];
    }
  }

  // --- Part 2: Display recently viewed products ---
  const recentlyViewedContainer = document.querySelector(
    "#recently-viewed-products-container",
  );
  if (!recentlyViewedContainer) return;

  const allProducts = getRecentlyViewed();
  // Filter out the currently viewed product
  const filteredProducts = allProducts.filter((p) => p.id !== currentProductId);
  const maxToShow =
    parseInt(recentlyViewedContainer.dataset.productsToShow) || 8;
  const products = filteredProducts.slice(0, maxToShow);

  if (products.length === 0) return;

  const sectionId = recentlyViewedContainer.dataset.sectionId;
  const slider = document.querySelector(`#recently-viewed-slider-${sectionId}`);
  const productList = slider?.querySelector("ul");
  if (!slider || !productList) return;

  // Fetch all product cards in parallel using Shopify's Section Rendering API
  const fetchPromises = products.map((product, index) =>
    fetch(`/products/${product.handle}?sections=dreambaby-recently-viewed-card`)
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then((data) => ({ index, html: data["dreambaby-recently-viewed-card"] }))
      .catch((err) => {
        console.warn(
          `[Recently Viewed] Could not load card for "${product.handle}":`,
          err,
        );
        return null;
      }),
  );

  const results = await Promise.all(fetchPromises);

  const parser = new DOMParser();
  let insertedCount = 0;

  results.forEach((result) => {
    if (!result?.html) return;
    const doc = parser.parseFromString(result.html, "text/html");
    // The section rendering API wraps content in a shopify-section div — unwrap it
    const sectionDiv = doc.body.firstElementChild;
    if (!sectionDiv) return;

    const li = document.createElement("li");
    li.className = "grid__item slider__slide";
    li.id = `Slide-${sectionId}-${insertedCount + 1}`;
    li.innerHTML = sectionDiv.innerHTML;

    productList.appendChild(li);
    insertedCount++;
  });

  if (insertedCount === 0) return;

  slider.classList.remove("hidden");
  recentlyViewedContainer.classList.remove("hidden");

  function updateSliderButtonsVisibility() {
    const sliderButtons = slider.querySelectorAll(".slider-buttons");
    if (!sliderButtons.length) return;

    const isScrollable = productList.scrollWidth > productList.clientWidth + 1;
    sliderButtons.forEach((buttons) => {
      buttons.classList.toggle("hidden", !isScrollable);
    });
  }

  // Re-initialize the slider now that slides have been injected
  const sliderComponent = slider.querySelector("slider-component");
  if (sliderComponent && typeof sliderComponent.resetPages === "function") {
    sliderComponent.resetPages();
  }

  updateSliderButtonsVisibility();
  window.addEventListener("resize", updateSliderButtonsVisibility);
});
